export default {
  // Host: 'http://13.209.100.21/api',
  // Host: 'https://api.crm.hobiengroup.com/api',
  Host: 'https://nayaapis.com/api/material/buyerCrm',
  HostRoot: 'https://nayaapis.com',
  HostPath: 'api/material/buyerCrm',
  HostV2: 'https://nayaapis.com/api/v2/buyer',
  Upload: 'https://nayaapis.com/api/v2/upload',
  Auth: 'auth',
  Config: 'config',
  Common: 'common',
  User: 'user',
  Order: 'order',
  Accounting: 'accounting',
  Statistics: 'statistics',
  Inquiry: 'inquiry',
  OrderSupport: 'orderSupport',
  SearchWord: 'searchWord',
  Recruitment: 'recruitment',
  Ledger: 'ledger',
  SalesNote: 'salesNote',
  FieldInvitation: 'fieldInvitation',
  InternalNotice: 'internal-notice',
  Main: 'main',
  PrivateNotes: 'private-notes',
  ProgressPayments: 'progress-payments',
  ExpenseApproval: 'expense-approval',
  Department: 'department',
  CustomerSupportChat: 'customer-support-chat',
  ShoppingCart: 'shopping-cart',
  Material: 'https://nayaapis.com/api/material/buyerB2C/material',
  CustomerSupportAutoReply: 'customer-support-auto-reply',
};
